// eslint-disable-next-line import-x/no-extraneous-dependencies
import shopRoutingData from '@root/shop/config/routes/compiled.json';
import { Router } from 'symfony-ts-router/dist/router';

import { markRoutingReady } from './routingReady';

const routerInstance = new Router();

if (typeof window === 'undefined' || !window.fos) {
  routerInstance.setRoutingData(shopRoutingData as never);
  markRoutingReady();
}

export const updateRoutingData = (data: unknown): void => {
  routerInstance.setRoutingData(data as never);
};

export default routerInstance;
